import React, { useState } from 'react';
import { Tabs, Tab, Paper } from '@mui/material';
import { CreateItemScreen } from './createItemScreen.js';
import { ViewItemsScreen } from './viewItemScreen.js';
import { CreateRecipeScreen } from './createRecipeScreen.js';
import { ViewRecipesScreen } from './viewRecipesScreen.js';
import { TabPanel } from '../../shared';
import { AppLayout } from '../../app/appLayout.js';

const ItemsScreen = ({ baseUrl }) => {
    let [selectedTab, setSelectedTab] = useState('0');
    let handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <AppLayout>
            <Paper>
                <Tabs
                    onChange={handleChange}
                    value={selectedTab}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="Create Item" value="0" />
                    <Tab label="View Items" value="1" />
                    <Tab label="Create Recipe" value="2" />
                    <Tab label="View Recipes" value="3" />
                </Tabs>
                <TabPanel selectedTab={selectedTab} index={'0'}>
                    <CreateItemScreen />
                </TabPanel>
                <TabPanel selectedTab={selectedTab} index={'1'}>
                    <ViewItemsScreen />
                </TabPanel>
                <TabPanel selectedTab={selectedTab} index={'2'}>
                    <CreateRecipeScreen />
                </TabPanel>
                <TabPanel selectedTab={selectedTab} index={'3'}>
                    <ViewRecipesScreen />
                </TabPanel>
            </Paper>
        </AppLayout>
    );
};

export { ItemsScreen };
